module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpys_three.073d91e5.png";